import { TotalDueToday } from "./TotalDueToday";
import { Value } from "./Value";

export const TotalDueLine = Object.assign(
  () => (
    <>
      <TotalDueToday />
      <Value />
    </>
  ),
  {
    Value,
  },
);
